import React from 'react'
import { Button } from './components/buttons/Button'
import { Icon } from './Icon'
import { Reveal, Section, SectionHead } from './primitives'

export function Industries() {
  const list = [
    ['zap', 'Electric Mobility'], ['shield', 'Defence'], ['plane', 'Aerospace'], ['ship', 'Marine'],
    ['train-front', 'Railways'], ['heart-pulse', 'Healthcare'], ['package', 'Logistics'], ['warehouse', 'Warehousing'],
  ];
  return (
    <Section label="Industries">
      <SectionHead eyebrow="Industries We Serve"
        title="Powering mission-critical operations across sectors." />
      <div style={{ display: 'grid', gap: 18, marginTop: 44 }} className="adr-ind-grid">
        {list.map(([ic, t], i) => (
          <Reveal key={t} variant="scale" delay={(i % 4) * 0.05}>
            <IndustryTile ic={ic} t={t} />
          </Reveal>
        ))}
      </div>
    </Section>
  );
}

export function IndustryTile({ ic, t }) {
  const [h, setH] = React.useState(false);
  return (
    <div onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)} style={{
      borderRadius: 'var(--radius-lg)', padding: '28px 22px', textAlign: 'center',
      background: h ? 'var(--grad-electric)' : 'var(--surface-card)',
      border: '1px solid var(--border-subtle)',
      transform: h ? 'translateY(-4px)' : 'none',
      boxShadow: h ? 'var(--glow-blue)' : 'var(--shadow-sm)',
      transition: 'all var(--dur-med) var(--ease-out)', cursor: 'pointer',
    }}>
      <span style={{ display: 'inline-flex', width: 54, height: 54, borderRadius: 14, alignItems: 'center', justifyContent: 'center', background: h ? 'rgba(255,255,255,0.16)' : 'var(--accent-soft)', color: h ? 'var(--energy-bright)' : 'var(--accent)', marginBottom: 14, transition: 'all var(--dur-med)' }}>
        <Icon name={ic} style={{ width: 26, height: 26 }} />
      </span>
      <div style={{ fontFamily: 'var(--font-heading)', fontWeight: 700, fontSize: 16, color: h ? '#fff' : 'var(--text-strong)' }}>{t}</div>
    </div>
  );
}

export function CTASection({ onNavigate }) {
  return (
    <Section label="CTA" style={{ padding: 'var(--section-y) 0' }}>
      <Reveal variant="scale" style={{
        position: 'relative', overflow: 'hidden', borderRadius: 'var(--radius-2xl)',
        background: 'var(--grad-blue-green)', padding: 'clamp(2.5rem,4vw,4.5rem)',
        textAlign: 'center', boxShadow: 'var(--shadow-xl)',
      }}>
        <div style={{ position: 'absolute', width: 360, height: 360, right: -80, top: -120, background: 'rgba(255,255,255,0.16)', borderRadius: '50%', filter: 'blur(60px)' }} />
        <div style={{ position: 'relative', zIndex: 1 }}>
          <h2 style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 'var(--fs-display-2)', color: '#fff', letterSpacing: '-0.02em', margin: '0 auto 18px', maxWidth: 820, lineHeight: 1.05 }}>
            Ready to build sustainable energy solutions?
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: 'var(--fs-lead)', maxWidth: 560, margin: '0 auto 32px' }}>
            Partner with ADIRATH to engineer batteries, storage, robotics and automation built for the future.
          </p>
          <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button variant="primary" size="lg" iconRight={<Icon name="arrow-right" style={{ width: 18, height: 18 }} />} onClick={() => onNavigate('Contact')}>Contact Us</Button>
            <Button variant="glass" size="lg" onClick={() => onNavigate('Contact')}>Request Proposal</Button>
          </div>
        </div>
      </Reveal>
    </Section>
  );
}
